import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { Elements, CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import axios from "axios";

// === Load your Stripe publishable key ===
const stripePromise = loadStripe(
  "pk_live_51SMDmMFrHXgrd3mjVOx4dvkppxjERzltozLa5ZAzVv7mbkh9Wi4FEyJwerybRMIfjY3aEn1kRjJyYg5DaPDwEx2j00wxlXKEp8"
);

const StripeFormBase = ({ history }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!stripe || !elements) return; // Stripe.js still loading
    setLoading(true);
    setMessage("");

    try {
      // Create PaymentIntent on your backend
      const { data } = await axios.post("/create-payment-intent", {
        amount: 50000, // 500 THB = 50,000 satang
        currency: "thb",
      });

      const clientSecret = data.clientSecret;
      const card = elements.getElement(CardElement);
      if (!card) {
        setMessage("Card element not found.");
        setLoading(false);
        return;
      }

      const result = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card,
          billing_details: { name: "Test User" },
        },
      });

      if (result.error) {
        setMessage(result.error.message || "Payment failed.");
      } else if (result.paymentIntent?.status === "succeeded") {
        setMessage("✅ ชำระเงินสำเร็จ!");
        // Redirect after short delay
        setTimeout(() => history.push("/logincredits500"), 1500);
      } else {
        setMessage(`สถานะการชำระเงิน: ${result.paymentIntent?.status || "unknown"}`);
      }
    } catch (err) {
      console.error(err);
      setMessage("เกิดข้อผิดพลาดในการสร้างการชำระเงิน");
    }

    setLoading(false);
  };

  return (
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <h2 style={{ marginBottom: 12 }}>Stripe Payment (THB)</h2>
      <form
        onSubmit={handleSubmit}
        style={{
          maxWidth: 420,
          margin: "0 auto",
          padding: 16,
          borderRadius: 12,
          boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
        }}
      >
        <div
          style={{
            padding: 12,
            border: "1px solid #e6e6e6",
            borderRadius: 8,
          }}
        >
          <CardElement
            options={{
              style: {
                base: {
                  fontSize: "16px",
                  color: "#32325d",
                  "::placeholder": { color: "#aab7c4" },
                },
                invalid: { color: "#fa755a" },
              },
            }}
          />
        </div>

        <button
          type="submit"
          disabled={!stripe || loading}
          style={{
            width: "100%",
            marginTop: 16,
            backgroundColor: "#0a74da",
            color: "white",
            padding: "12px 16px",
            border: "none",
            borderRadius: 8,
            cursor: !stripe || loading ? "not-allowed" : "pointer",
            fontWeight: 600,
          }}
        >
          {loading ? "กำลังดำเนินการ..." : "ชำระเงิน 500 บาท"}
        </button>

        {message && <p style={{ marginTop: 12 }}>{message}</p>}
      </form>
    </div>
  );
};

// Wrap the form with withRouter
const StripeForm = withRouter(StripeFormBase);

// ----------------------
// Standalone page export
// ----------------------
const StripePage500 = () => (
  <Elements stripe={stripePromise}>
    <StripeForm />
  </Elements>
);

export default StripePage500;
